export enum HotelStatus {
  OFFLINE = 0,
  PUBLISHED = 1,
  HIDDEN = 2,
}

export interface DayPeriod {
  name: string;
  is_active: boolean;
}

export interface DiscountRule {
  start_date: string;
  end_date: string;
}

export interface HotelLabel {
  id: number;
  name: string;
  code?: string;
  is_active?: boolean;
}

export interface InternalNote {
  id?: number;
  note: string;
  date?: string;
  created_at?: string;
  user_id?: number;
  user_name?: string;
  user?: {
    id: number;
    name: string;
  };
}

export interface ChannelManager {
  id: number;
  name: string;
}

export interface HotelArchiveHistoryEntry {
  action: 'archived' | 'restored';
  at: string;
  by: string;
  reason: string | null;
}
